export enum orderActionTypes {
	SET_ORDER_ACTIVITY_LOG_LISTS_LOADING = 'SET_ORDER_ACTIVITY_LOG_FILTER_LOADING',
	FETCH_ORDER_ACTIVITY_LOG_LISTS = 'FETCH_ORDER_ACTIVITY_LOG_LISTS',
	SET_ORDER_ACTIVITY_LOG_DATA_LOADING = 'SET_ORDER_ACTIVITY_LOG_DATA_LOADING',
	FETCH_ORDER_ACTIVITY_LOG_DATA = 'FETCH_ORDER_ACTIVITY_LOG_DATA',
	FETCH_ACTIVITY_LISTS_FAIL = 'FETCH_ACTIVITY_LISTS_FAIL',
	START_REPORT_LIST_LOADING = 'START_REPORT_LIST_LOADING',
	FETCH_REPORT_TYPES_LIST = 'FETCH_REPORT_TYPES_LIST',
	START_LOADING = 'START_LOADING',
	END_LOADING = 'END_LOADING',
	SET_ORDER_LIST_DATA_LOADING = 'SET_ORDER_LIST_DATA_LOADING',
	FETCH_ORDER_TABLE_DATA = 'FETCH_ORDER_TABLE_DATA',
	FETCH_ORDER_STATUSES = 'FETCH_ORDER_STATUSES',
	FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA',
	SET_ORDER_TABLE_DATA_DEFAULT = 'SET_ORDER_TABLE_DATA_DEFAULT',
	SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING',
	SET_ORDER_DETAILS_DATA_LOADING = 'SET_ORDER_DETAILS_DATA_LOADING',
	FETCH_ORDER_DETAILS_DATA = 'FETCH_ORDER_DETAILS_DATA',
	SET_ACTIVITY_LOG_LIST_LOADING = 'SET_ACTIVITY_LOG_LIST_LOADING',
	FETCH_ACTIVITY_LOG_LISTS = 'FETCH_ACTIVITY_LOG_LISTS',
	START_REFUND_ITEMS_LOADING = 'START_FETCH_REFUND_ITEMS_LOADING',
	END_REFUND_ITEMS_LOADING = 'END_FETCH_REFUND_ITEMS_LOADING',
	SET_DASHBOARD_CASH_DATA = 'SET_DASHBOARD_CASH_DATA',
	START_CANCEL_ORDER_LOADING = 'START_CANCEL_ORDER_LOADING',
	END_CANCEL_ORDER_LOADING = 'END_CANCEL_ORDER_LOADING',
	START_EXPORT_CSV_LOADING = 'START_EXPORT_CSV_LOADING',
	END_EXPORT_CSV_LOADING = 'END_EXPORT_CSV_LOADING',
	SET_ORDER_TABLE_PAGINATION = 'SET_ORDER_TABLE_PAGINATION',
	SET_ORDER_TABLE_SORTING = 'SET_ORDER_TABLE_SORTING',
	SET_ACTIVITY_LOG_TABLE_PAGINATION = 'SET_ACTIVITY_LOG_TABLE_PAGINATION',
	SET_ORDER_STATUSES_LOADING = 'SET_ORDER_STATUSES_LOADING',
	SET_PARTNERS_COMMISSIONS_LOADING = 'SET_PARTNERS_COMMISSIONS_LOADING',
	FETCH_PARTNERS_COMMISSIONS = 'FETCH_PARTNERS_COMMISSIONS',
	SET_PARTNERS_COMMISSIONS_BY_ID_LOADING = 'SET_PARTNERS_COMMISSIONS_BY_ID_LOADING',
	FETCH_PARTNERS_COMMISSIONS_BY_ID = 'FETCH_PARTNERS_COMMISSIONS_BY_ID',
	SET_PARTNERS_COMMISSIONS_DETAILS_LOADING = 'SET_PARTNERS_COMMISSIONS_DETAILS_LOADING',
	FETCH_PARTNERS_COMMISSIONS_DETAILS = 'FETCH_PARTNERS_COMMISSIONS_DETAILS',
	SET_AGENCIES_COMMISSIONS_LOADING = 'SET_AGENCIES_COMMISSIONS_LOADING',
	FETCH_AGENCIES_COMMISSIONS = 'FETCH_AGENCIES_COMMISSIONS',
	SET_AGENCIES_COMMISSIONS_BY_ID_LOADING = 'SET_AGENCIES_COMMISSIONS_BY_ID_LOADING',
	FETCH_AGENCIES_COMMISSIONS_BY_ID = 'FETCH_AGENCIES_COMMISSIONS_BY_ID',
	SET_AGENCIES_COMMISSIONS_DETAILS_LOADING = 'SET_AGENCIES_COMMISSIONS_DETAILS_LOADING',
	FETCH_AGENCIES_COMMISSIONS_DETAILS = 'FETCH_AGENCIES_COMMISSIONS_DETAILS',
	SET_FUNDS_RESERVE_LIST_LOADING = 'SET_FUNDS_RESERVE_LIST_LOADING',
	FETCH_FUNDS_RESERVE_LIST = 'FETCH_FUNDS_RESERVE_LIST',
	SET_FUNDS_RESERVE_LIST_TO_DEFAULT = 'SET_FUNDS_RESERVE_LIST_TO_DEFAULT',
	SET_FUNDS_RESERVE_LIST_PAGINATION = 'SET_FUNDS_RESERVE_LIST_PAGINATION',
	SET_FUNDS_RESERVE_LIST_DETAILS_LOADING = 'SET_FUNDS_RESERVE_LIST_DETAILS_LOADING',
	FETCH_FUNDS_RESERVE_DETAILS_LIST = 'FETCH_FUNDS_RESERVE_DETAILS_LIST',
	SET_FUNDS_RESERVE_DETAILS_LIST_PAGINATION = 'SET_FUNDS_RESERVE_DETAILS_LIST_PAGINATION',

	SET_ORDER_FAVORITE_FILTERS = 'SET_ORDER_FAVORITE_FILTERS',

	SET_ORDER_FILTER_STATE = 'SET_ORDER_FILTER_STATE',
	SET_ORDER_RETAILS_DATA_TO_DEFAULT = 'SET_ORDER_RETAILS_DATA_TO_DEFAULT',
}
